import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/styles.scss'
import i18n from '@/i18n';

import Keycloak, { KeycloakConfig, KeycloakOnLoad } from 'keycloak-js';
import axiosClient from '@/axios';
import LogRocket from 'logrocket';
import { AxiosRequestConfig } from 'axios';

const logRocketId = process.env.VUE_APP_LOGROCKET_ID;

const initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
  onLoad: 'login-required',
};

const keycloak = new Keycloak(initOptions as KeycloakConfig);

let tokenInterceptor: number;

keycloak
  .init({ onLoad: initOptions.onLoad as KeycloakOnLoad })
  .then((auth: boolean) => {
    if (!auth) {
      window.location.reload();
    } else {
      const logRocketEnv = process.env.VUE_APP_LOGROCKET_ENV;
      const userEmail = keycloak.tokenParsed?.email as string | undefined;

      if (logRocketId) {
        LogRocket.init(logRocketId);
        if (userEmail) {
          LogRocket.identify(userEmail, {
            email: userEmail,
            env: logRocketEnv,
          });
        }
      }

      if (keycloak.token) {
        tokenInterceptor = createTokenInterceptor(keycloak.token);
      }

      createApp(App)
        .use(i18n)
        .use(store)
        .use(router)
        .provide('keycloak', keycloak)
        .mount('#app')
    }

    setInterval(() => {
      keycloak.updateToken(70).then((refreshed: boolean) => {
        if (!refreshed) return;

        if (tokenInterceptor) axiosClient.interceptors.request.eject(tokenInterceptor);

        if(keycloak.token) tokenInterceptor = createTokenInterceptor(keycloak.token);
      });
    }, 6000);
  });

const createTokenInterceptor = (token: string): number => {
  return axiosClient.interceptors.request.use(function (
    config: AxiosRequestConfig
  ) {
    config.headers = {
      ...config.headers,
      ...{
        'Authorization-Token': `${token}`
      }
    };

    return config;
  });
};
